export const API_REQUEST_ERRORS = {
	MEMBERSHIP_LOGIN: 'membership-login',
	IDENTITY_API_EXISTS: 'identityApi-exists',
	INQUIRY: 'inquiry',
	MEMBERSHIP_SIGNUP: 'membership-signup',
	MEMBERSHIP_TOKEN: 'membership-token',
	MEMBERSHIP_UPDATE: 'membership-update',
	WEDDING_SDK_GET: 'weddingSDK-get',
	WEDDING_SDK_UPSERT: 'weddingSDK-upsert',
	SAVED_VENDORS_CREATE: 'savedVendors-create',
} as const;
